import { Injectable } from '@angular/core';
import { ProductListByIdsConfigService } from 'gung-standard';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CarLinerProductListByIdsConfigService extends ProductListByIdsConfigService {
  getItems() {
    return super.getItems().pipe(
      map(products =>
        products
          .filter(p => p.extra.ar.lagtyp !== 11)
          .sort((a, b) => {
            // Helper function to get the part of id before "-"
            const extractId = (id) => {
              const parts = id.split("-");
              return parts[0]; // Take everything before "-"
            };
          
            const idA = extractId(a.id);
            const idB = extractId(b.id);
          
            // Compare the extracted parts as numbers
            return Number(idA) - Number(idB);
          })
      )
    );
  }
}
